var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.loading
      ? _c(
          "div",
          [
            _vm.hasNewLeftNavEnabled
              ? _c("new-main-header", [
                  _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    "),
                ])
              : _c("main-header", [
                  _c(
                    "span",
                    { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Back to Devices",
                            placement: "bottom-start",
                          },
                        },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "Devices",
                                  params: { id: _vm.$route.params.id },
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-back" })]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: !_vm.pageTitle,
                          expression: "!pageTitle",
                        },
                      ],
                      attrs: { slot: "page-title" },
                      slot: "page-title",
                    },
                    [_vm._v(_vm._s(_vm.pageTitle))]
                  ),
                ]),
            _vm._v(" "),
            _vm.meta.device.found
              ? _c(
                  "div",
                  [
                    _c("main-content", [
                      _c(
                        "div",
                        {
                          attrs: { slot: "main-content" },
                          slot: "main-content",
                        },
                        [
                          _vm.loading
                            ? _c("div")
                            : _vm.doorbotId
                            ? _c(
                                "div",
                                [
                                  _c("Troubleshooting", {
                                    attrs: { data: _vm.dynamicTags },
                                  }),
                                  _vm._v(" "),
                                  _c("device-general", {
                                    attrs: {
                                      id: "device-general",
                                      loading: _vm.loading,
                                      device: _vm.device,
                                      "last-status-report":
                                        _vm.lastStatusReport,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.showSection("firmwares") &&
                                  !_vm.isBaseStation
                                    ? _c("device-firmware", {
                                        attrs: {
                                          id: "device-firmwares",
                                          device: _vm.device,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isDeviceWithScheduleSupport
                                    ? _c("schedules", {
                                        attrs: {
                                          "device-name": _vm.deviceName,
                                        },
                                      })
                                    : _vm.isDeviceWithScheduleSupport
                                    ? _c("old-schedules", {
                                        attrs: {
                                          "device-name": _vm.deviceName,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showSection("device-settings") &&
                                  !_vm.isBaseStation
                                    ? _c("device-settings", {
                                        attrs: { id: "device-settings" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("device-links", {
                                    attrs: { id: "device-links" },
                                  }),
                                  _vm._v(" "),
                                  _vm.isChime
                                    ? _c("linked-devices", {
                                        attrs: { "chime-id": _vm.doorbotId },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isNotChime && _vm.showSection("events")
                                    ? _c("events", {
                                        attrs: {
                                          id: "device-events",
                                          "by-device": true,
                                          "device-type": _vm.deviceType,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showSection("reports-summary")
                                    ? _c("device-status-reports", {
                                        attrs: {
                                          id: "device-status-reports",
                                          device: _vm.device,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showSection("setups")
                                    ? _c("device-setups", {
                                        attrs: {
                                          id: "device-setups",
                                          "show-device-name": false,
                                          entity: {
                                            model: "devices",
                                            id: _vm.doorbotId,
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _c("div", [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "2rem",
                "text-align": "center",
                margin: "20px auto",
                width: "50%",
                color: "#1998d5",
              },
            },
            [
              _c(
                "p",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "circle-notch", spin: "" },
                  }),
                  _vm._v("\n        Loading device...\n      "),
                ],
                1
              ),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }